import { apiRequest } from "../../services/apiService";
import { isAuthToken } from "../../services/authToken";
import { LOGIN_FAIL, LOGIN_REQUEST, LOGIN_SUCCESS, RESEND_OTP_FAIL, RESEND_OTP_REQUEST, RESEND_OTP_SUCCESS, VERIFY_OTP_FAIL, VERIFY_OTP_REQUEST, VERIFY_OTP_SUCCESS } from "../constant";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//User Auth
export const checkLogin = (data, callBack, onMfaRequired) => {
    return async (dispatch) => {
        localStorage.removeItem('token_id');
        dispatch({ type: LOGIN_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/users/checkLogin`,
            data: data
        })
        if (response) {
            //console.log("response>>???",response)
            if (response.data.statusCode === 200) {
                if (response.data.result === 'mfa_required' || response.data.data?.mfa_required) {
                    dispatch({ type: 'RESET_LOGIN' });
                    if (onMfaRequired && response.data.data?.user_id) {
                        onMfaRequired(response.data.data);
                    } else {
                        dispatch(loginFailure('Email verification is required. Please try logging in again.'));
                    }
                    return;
                }
                const token = response.data?.data?.token_id;
                if (!isAuthToken(token)) {
                    dispatch(loginFailure('Login did not return a valid session. Please try again.'));
                    return;
                }
                localStorage.setItem('token_id', token);
                // window.location = '/admin/survey/list';
                dispatch({ type: LOGIN_SUCCESS })
                //console.log("token RES ACTION", response.data?.data?.token_id);
                callBack(response.data?.data?.token_id);
            } else if (response.data.statusCode === 202) {
                //console.log("cff",response.data.data[0].id)
                const checkUserRole = await apiRequest({
                    method: 'post',
                    url: `/teams/getUserTeamRole`,
                    data: { user_id: response.data.data[0].id }
                })
                //console.log("checkUserRole",checkUserRole);
                // window.location = '/EmailVerification/?email=' + email;
                if (checkUserRole.response.data.statusCode === 200) {
                    const apiData = await apiRequest({
                        method: 'GET',
                        url: `/users/resendRegistrationOtp?email=${data?.email}`,
                        data: data
                    })
                    if (apiData.response) {

                        if (apiData.response?.status === 200) {
                            window.location = `/EmailVerification/?email=${data?.email}`;
                        } else {
                            //console.log("Unable to send OTP up..");
                        }
                    }
                } else {
                    //console.log("test")
                    window.location = `/team-verification/`;
                }
            }
            else {
                dispatch({ type: LOGIN_FAIL, payload: { response } });
            }
        }
        else if (error) {
            dispatch({ type: LOGIN_FAIL, payload: error })
        }
    }
}

const loginFailure = (msg) => ({
    type: LOGIN_FAIL,
    payload: { response: { data: { statusCode: 400, msg } } }
});

export const verifyMfa = (data, callBack) => async (dispatch) => {
    dispatch({ type: LOGIN_REQUEST });
    const { response, error } = await apiRequest({ method: 'POST', url: '/users/verify-mfa', data });
    const token = response?.data?.data?.token_id;
    if (response?.data?.statusCode === 200 && isAuthToken(token)) {
        localStorage.setItem('token_id', token);
        dispatch({ type: LOGIN_SUCCESS });
        callBack(token);
    } else {
        dispatch(error ? { type: LOGIN_FAIL, payload: error } :
            loginFailure(response?.data?.msg || 'Verification did not return a valid session. Please try again.'));
    }
};

//Token Data
export const getTokenData = (setuserId) => {
    return async (dispatch) => {
        const token_id = localStorage.getItem('token_id');
        const { response, error } = await apiRequest({
            method: 'GET',
            url: `/auth/getTokenData?token_id=${token_id}`,
        })
        if (response) {
            setuserId(response?.data?.user_id);
        }
        else if (error) {
            window.location = '/';
        }
    }
}

export const verifyOtp = (data, callBack) => {
    return async (dispatch) => {
        dispatch({ type: VERIFY_OTP_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/users/verify-otp`,
            data: data
        })
        if (response) {
            if (response.data.statusCode === 200) {
                dispatch({ type: VERIFY_OTP_SUCCESS })
                localStorage.setItem('token_id', data.token);
                // window.location = '/admin/survey/list';
                dispatch({ type: LOGIN_SUCCESS })
                callBack();
            } else {
                dispatch({ type: VERIFY_OTP_FAIL })
            }
        }
        else if (error) {
            toast.error("Invalid OTP!");
            dispatch({ type: VERIFY_OTP_FAIL })
        }
    }
}

export const resendOtp = (data, callBack) => {
    return async (dispatch) => {
        dispatch({ type: RESEND_OTP_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/users/resend-otp`,
            data: data
        })
        if (response) {
            if (response.data.statusCode === 200) {
                dispatch({ type: RESEND_OTP_SUCCESS })
                callBack();
            } else {
                //console.log("Unable to RESEND OTP");
            }
        }
        else if (error) {
            dispatch({ type: RESEND_OTP_FAIL })
        }
    }
}

export const signUpverifyOtp = (data, callBack) => {
    return async (dispatch) => {
        dispatch({ type: VERIFY_OTP_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/users/signUpOtpCheck`,
            data: data
        })
        if (response) {
            if (response.data.statusCode === 200) {
                dispatch({ type: VERIFY_OTP_SUCCESS })
                localStorage.setItem('token_id', response.data.token_id);
                //window.location = '/admin/roi';
                dispatch({ type: LOGIN_SUCCESS })
                callBack();
            } else {
                dispatch({ type: VERIFY_OTP_FAIL })
            }
        }
        else if (error) {
            toast.error("Invalid OTP!");
            dispatch({ type: VERIFY_OTP_FAIL })
        }
    }
}
